import { render, staticRenderFns } from "./About.vue?vue&type=template&id=1078a4e1&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=1078a4e1&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078a4e1",
  null
  
)

export default component.exports